import { Checkbox } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";

import { RanaModal } from "@nens/ranalib";

import { cancelButtonText } from "@/translations";

export interface ProjectConfirmMoveModalProps {
  moveFiles: () => void;
  dontConfirmMove: boolean;
  setDontConfirmMove: (dontConfirmMove: boolean) => void;
  onClose: () => void;
}

export function ProjectConfirmMoveModal({
  onClose,
  moveFiles,
  dontConfirmMove,
  setDontConfirmMove,
}: ProjectConfirmMoveModalProps) {
  const intl = useIntl();

  return (
    <RanaModal
      isOpen
      maxW="lg"
      onClose={onClose}
      topBar={<FormattedMessage id="header.move_files_confirm" defaultMessage="Are you sure?" />}
      buttons={[
        {
          children: cancelButtonText,
          variant: "tertiary",
          onClick: onClose,
        },
        {
          children: intl.formatMessage({
            id: "button.move",
            defaultMessage: "Move",
          }),
          variant: "primary",
          onClick: () => {
            moveFiles();
            onClose();
          },
        },
      ]}
      bottomChild={
        <Checkbox isChecked={dontConfirmMove} onChange={() => setDontConfirmMove(!dontConfirmMove)}>
          <FormattedMessage
            id="move.confirm.dont_show_again"
            defaultMessage="Don't show this popup again"
          />
        </Checkbox>
      }
    >
      <FormattedMessage
        id="move.confirm.text"
        defaultMessage="You are about to move a folder. Moving large folders can take a while."
      />
    </RanaModal>
  );
}
